import {
  getGoodsSupplyCase,
  getStocksInStores,
  getIsOnlineOnly,
  GoodsSupplyCase,
  StoreStockData,
} from 'features/goods-supply';
import { isWebSellable } from 'features/product-info';
import { styled } from 'linaria/react';
import React from 'react';
import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';
import { ConnectedProps } from 'types/utils';
import { OnlineOrderOnlyMessage } from 'features/product-info/components/online-order-only-message';

type PickedStockData = Pick<StoreStockData, 'storeFullName' | 'stockValue' | 'stockUnit' | 'displaySample'>;

type StocksInStoresMappedState = {
  stocks: PickedStockData[];
  supplyCase: GoodsSupplyCase | null;
  isSellable: boolean;
  isOnlineOnly: boolean;
};
type StocksInStoresProps = ConnectedProps<StocksInStoresMappedState> & React.HTMLAttributes<HTMLDivElement>;

export const OnlineOrderOnly: React.FC<StocksInStoresProps> = ({
  stocks,
  supplyCase,
  isSellable,
  isOnlineOnly,
  ...htmlProps
}) => {
  const itHasEmptyStocksRecords =
    stocks.length > 0 && !stocks.some((stock: PickedStockData) => stock.stockValue > 0);
  const onlineOrderOnlyDisabled =
    itHasEmptyStocksRecords && stocks.some((stock: PickedStockData) => !!stock.displaySample);
  const isCaseWithOnlineOnlyMessage = supplyCase === 'CASE_3' || supplyCase === 'CASE_7';
  const shouldRender =
    isSellable &&
    !onlineOrderOnlyDisabled &&
    (isCaseWithOnlineOnlyMessage || isOnlineOnly || itHasEmptyStocksRecords);

  if (!shouldRender) {
    return null;
  }

  return (
    <StyledContainer slot="online-order-only" data-qa="pdp-online-order-only">
      <OnlineOrderOnlyMessage {...htmlProps} />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  padding-bottom: var(--space-250);
`;

const mapStoreToProps = (store: RootReducer): StocksInStoresMappedState => {
  const stocks = getStocksInStores(store);
  const supplyCase = getGoodsSupplyCase(store);
  const isSellable = isWebSellable(store);
  const isOnlineOnly = getIsOnlineOnly(store);

  return {
    stocks,
    supplyCase,
    isSellable,
    isOnlineOnly,
  };
};

export const PdpOnlineOrderOnly = connect(mapStoreToProps)(OnlineOrderOnly);
